module.exports = __webpack_public_path__ + "static/img/yangan.50376c5e.png";